import { TValidSdcColumns } from './../../sdc-columns.type';
import { sdcStateConfigConstant } from './../sdc-state-config.constant';
import {
  IColumnSort,
  IFilter,
  IGridViews,
  ISdcActivity,
  TValidSdcStates,
  TValidSdcViews,
} from './../sdc-state.typings';

export class NextTermPlanningConfigService implements ISdcActivity {
  get humanName() {
    return sdcStateConfigConstant.NEXT_TERM_PLANNING_TABLE.humanName;
  }

  get state(): TValidSdcStates {
    return sdcStateConfigConstant.NEXT_TERM_PLANNING_TABLE.state;
  }

  get columns(): TValidSdcColumns[] {
    return ['studentName', 'studentId'];
  }

  get hiddenColumns(): TValidSdcColumns[] {
    return [];
  }

  get gridViews(): IGridViews {
    return {};
  }

  get filter(): IFilter {
    return {};
  }

  get sort(): IColumnSort[] {
    return [];
  }

  // Not needed, no bundle
  get bundleName() {
    return null;
  }

  get availableSdcViews(): TValidSdcViews[] {
    return [];
  }
}
